import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import { useAppManager } from 'core/hooks';

// TODO: Move Panel / LargePanel to /components?
import LargePanel from 'libs/rendering/gltf/components/largePanel/largePanel';
import { Button } from 'components';

import MultiPartFile from 'apps/rfq/rfqForm/views/multiPartFile';
import Onboarding from 'apps/rfq/rfqForm/views/onboarding';
import { JobSpecDetailsForm } from 'apps/jobSpec/views/jobSpecDetailsForm';

import RFQAppManager from 'apps/rfq/appManager';

import { MaterialOption } from 'apps/rfq/rfqForm/views/materialOption';
import { ComponentRegistry } from 'core';
import 'apps/addresses';

import { useViewerControl } from 'libs/rendering/gltf/hooks';
import { clientStore } from 'apps/client/app';
import { routerStore } from 'core/routing';
import { confToFields } from 'libs/forms/index';

import { SubmitWrapper } from 'apps/jobSpec/views/jobSpecDetailsForm.styled';

ComponentRegistry.add('rfq.MaterialOption', MaterialOption);

const RFQForm = props => {
  const { file, simpleForm, t } = props;
  const viewerControl = useViewerControl();
  const rfqAppManager = useAppManager(
    RFQAppManager,
    null,
    {
      file,
      signedInProfile: clientStore.signedInProfile,
      viewerControl,
    },
    true,
    [file],
  );

  // - we want to show the rfq form, but we need to decide if we
  // want to show the multi-part form (with instructions how to
  // extract a part), or the details form (which is the main form
  // where you can pick the material, process etc.)
  // - there is a flag viewerControl.isSinglePartFile, but that is
  // unreliable on its own, when we have a file loaded into the
  // viewer and its in the background, this might be true, we want
  // want to know about the file we're going to load _next_ if its
  // a single part file
  // - to do that we can check the lastLoadedId (same logic as in
  // gltf/viewer.js when we decide to load new or just display the
  // current file)
  let shouldRenderDetailsForm = false;
  if (file && viewerControl.lastLoadedId === file?.id) {
    if (viewerControl.isSinglePartFile) {
      shouldRenderDetailsForm = true;
    } else if (routerStore.params.get('partId')) {
      shouldRenderDetailsForm = true;
    }
  }

  if (
    !file ||
    !viewerControl.lastLoadedId ||
    viewerControl.isSinglePartFile === undefined
  ) {
    shouldRenderDetailsForm = true;
  }

  const submitting = rfqAppManager.submittingRfqForm;
  const submittingText = t('Submitting...');
  const submitText = t('Submit RFQ');

  const rfqSubmitButton = (
    <SubmitWrapper>
      <Button
        data-test-id='submit-rfq-button'
        text={submitting ? submittingText : submitText}
        disabled={submitting}
        loading={submitting}
        onClick={() => rfqAppManager.Submit()}
        icon='arrow_right'
        iconPosition='right'
      />
    </SubmitWrapper>
  );

  const addressField = confToFields({
    formStore: rfqAppManager.addressFormStore,
    refs: {},
    responsive: true,
  });
  // TODO: we should create a third form to display while loading
  // when we don't know yet if the file we're loading is multi-part
  // or single-part
  return (
    <LargePanel>
      {shouldRenderDetailsForm ? (
        <>
          <Onboarding />
          <JobSpecDetailsForm
            jobSpecManager={rfqAppManager.jobSpecManager}
            simpleForm={simpleForm}
            // TODO (david): Move these two props as their own components outside of JobSpecDetailsForm
            submitButton={rfqSubmitButton}
            addressField={addressField}
          />
        </>
      ) : (
        <MultiPartFile />
      )}
    </LargePanel>
  );
};

RFQForm.propTypes = {
  routerStore: PropTypes.object,
  fileFormatObject: PropTypes.object,
  simpleForm: PropTypes.bool,
  file: PropTypes.object,
};

export default withNamespaces()(observer(RFQForm));
